/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 9th Sept 2019
 *
 *  Location Profile View
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import AddressForm from 'components/Forms/AddressForm';
import TextFieldWithValidation from 'components/InputFields/TextFieldWithValidation';

// Material UI Components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { useStores } from 'stores/RootStore';

const Profile = props => {
  const { classes } = props;
  const stores = useStores();
  const { isLoading, hasChanges, handleNameChange, handleAddressChange, onSubmit } = stores.locationStore;
  const { name, address } = stores.locationStore.location;

  // Update AppStore Page View
  stores.appStore.setView('Profile');

  return (
    <Grid container direction='column'>
      <Grid item xs={12} md={8} lg={5}>
        <Grid container className={classes.gridContainer}>
          <Grid item sm={12} className={classes.addressGridItem}>
            <Grid container direction='column'>
              <form autoComplete='on' action='' onSubmit={onSubmit}>
                <Grid item xs={12}>
                  <TextFieldWithValidation
                    id='name'
                    name='Location Name'
                    type='text'
                    required
                    visible
                    message='Office name is a required field.'
                    value={name || ''}
                    handleInputChange={handleNameChange}
                    label='Office Name'
                    className={classes.defaultInputField}
                    fullWidth
                    margin='dense'
                    InputProps={{
                      className: classes.inputText,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelText,
                    }}
                  />
                </Grid>
                <Grid item xs={12} className={classes.addressWrapper}>
                  <Typography variant='body1' color='textSecondary' className={classes.sectionTitle}>
                    Address Information:
                  </Typography>
                  <Divider className={classes.sectionDivider} />
                  {isLoading ? null : (
                    <AddressForm
                      address1
                      address2
                      city
                      state
                      zip
                      address1Value={address.address1}
                      address2Value={address.address2}
                      cityValue={address.city}
                      stateValue={address.state}
                      zipValue={address.zip}
                      handleInputUpdate={handleAddressChange}
                      toStore={false}
                      passValues={true}
                      prefix={'location'}
                    />
                  )}
                </Grid>
                <Grid item>
                  <Button
                    disabled={!hasChanges}
                    variant='contained'
                    type='submit'
                    color='primary'
                    className={classes.saveButton}
                  >
                    Save
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  gridContainer: {
    paddingBottom: '40px',
  },
  addressWrapper: {
    marginTop: '5px',
  },
  addressGridItem: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '5px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '15px',
      paddingLeft: '15px',
    },
  },
  avatarInput: {
    paddingTop: '50px',
  },
  avatarFooter: {
    fontSize: '10pt',
    textAlign: 'center',
  },
  sectionTitle: {
    marginTop: '15px',
    fontWeight: 600,
    color: theme.palette.primary.light,
  },
  sectionTitleLeft: {
    marginTop: '20px',
    marginLeft: '30px',
    fontWeight: 600,
  },
  sectionDivider: {
    width: '100%',
  },
  defaultInputField: {
    padding: '2px',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
    },
  },
  inputLabelText: {
    fontSize: '11pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
  },
  saveButton: {
    marginTop: '25px',
  },
});

export default withStyles(styles, { withTheme: true })(observer(Profile));
